export default "__VITE_ASSET__By6_pjYT__"